import {useMemo} from 'react';
import {getNetworkStatus} from 'utils/functions/checkNetworkStatus';

const MOBILE_USER_AGENTS =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const IOS_USER_AGENTS = /iPhone|iPad|iPod/i;
const ANDROID_USER_AGENTS = /Android/i;

const MOBILE_USER_AGENT_DICTIONARY: Record<string, 'ios' | 'android'> = {
  iPad: 'ios',
  iPhone: 'ios',
  iPod: 'ios',
  Android: 'android',
};

export interface UseMobileReturn {
  isPWA: boolean;
  isIos: boolean;
  isAndroid: boolean;
  getAccessSource(): Promise<string>;
  isMobile: boolean;
}

export const useMobile = (): UseMobileReturn => {
  const isPWA = window.matchMedia('(display-mode: standalone)').matches;
  const isMobile = MOBILE_USER_AGENTS.test(navigator.userAgent);
  const isIos = IOS_USER_AGENTS.test(navigator.userAgent);
  const isAndroid = ANDROID_USER_AGENTS.test(navigator.userAgent);

  const userAgent = useMemo((): string => {
    if (!isPWA) return 'web';

    const matchedAgent = String(navigator.userAgent.match(MOBILE_USER_AGENTS));
    const mobileAgent = MOBILE_USER_AGENT_DICTIONARY[matchedAgent] ?? 'other';

    return `pwa_${mobileAgent}`;
  }, [isPWA]);

  async function getAccessSource(): Promise<string> {
    const networkPrefix = await getNetworkStatus().then((status) => {
      return status === 'online' ? '' : 'offline_';
    });

    return `${isPWA ? networkPrefix : ''}${userAgent}`;
  }
  return {
    isPWA,
    isIos,
    isAndroid,
    getAccessSource,
    isMobile,
  };
};
